import React, { useState, useRef, useEffect } from 'react';
import { Icon } from '../common/Icons';

export default function NoteCard({ note, doc, layout = 'grid', onClick, onEdit, onDelete }) {
  const item = note || doc;
  const [copied, setCopied] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;
    const closeHandler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', closeHandler);
    return () => document.removeEventListener('mousedown', closeHandler);
  }, [menuOpen]);

  const handleCopy = (e) => {
    e?.stopPropagation();
    const textToCopy = `${item?.title ? `${item.title}\n\n` : ''}${item?.content || ''}`.trim();
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    }
  };

  const categoryName = item?.categoryName || item?.folderName || 'General';

  if (layout === 'list') {
    return (
      <div className={`note-list-row doc-list-row ${menuOpen ? 'menu-active' : ''}`} onClick={onClick} role="button" tabIndex={0}>
        <div className="note-list-main doc-list-main">
          <div className="note-list-info doc-list-info">
            <div className="note-title-row doc-title-row">
              <h3 className="note-list-title doc-list-title">{item?.title}</h3>
              <span className="folder-badge sm">
                <Icon name="category" size={11} />
                <span>{categoryName}</span>
              </span>
            </div>
            <p className="note-list-snippet doc-list-snippet">{item?.content}</p>
          </div>
        </div>

        <div className="note-card-actions doc-card-actions" onClick={e => e.stopPropagation()}>
          <div className="card-hamburger-menu-wrap" ref={menuRef}>
            <button
              type="button"
              className={`action-btn-pill menu-trigger ${menuOpen ? 'active' : ''}`}
              title="More actions"
              onClick={e => {
                e.stopPropagation();
                setMenuOpen(prev => !prev);
              }}
              aria-label="More actions"
            >
              <Icon name="more-vertical" size={15} />
            </button>

            {menuOpen && (
              <div className="card-menu-dropdown right-aligned">
                <button
                  type="button"
                  className="card-menu-item"
                  onClick={e => {
                    handleCopy(e);
                    setMenuOpen(false);
                  }}
                >
                  <Icon name={copied ? 'check' : 'copy'} size={13} />
                  <span>{copied ? 'Copied!' : 'Copy Content'}</span>
                </button>
                <button
                  type="button"
                  className="card-menu-item"
                  onClick={e => {
                    e.stopPropagation();
                    setMenuOpen(false);
                    onEdit?.(item);
                  }}
                >
                  <Icon name="edit" size={13} />
                  <span>Edit Note</span>
                </button>
                <button
                  type="button"
                  className="card-menu-item danger"
                  onClick={e => {
                    e.stopPropagation();
                    setMenuOpen(false);
                    onDelete?.(item);
                  }}
                >
                  <Icon name="trash" size={13} />
                  <span>Move to Trash</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`note-card doc-card ${menuOpen ? 'menu-active' : ''}`} onClick={onClick} role="button" tabIndex={0}>
      <div className="note-card-top doc-card-top">
        <div className="note-card-folder-badge doc-card-folder-badge">
          <Icon name="category" size={12} />
          <span>{categoryName}</span>
        </div>

        <div className="note-card-actions doc-card-actions" onClick={e => e.stopPropagation()}>
          <div className="card-hamburger-menu-wrap" ref={menuRef}>
            <button
              type="button"
              className={`action-btn-pill menu-trigger ${menuOpen ? 'active' : ''}`}
              title="More actions"
              onClick={e => {
                e.stopPropagation();
                setMenuOpen(prev => !prev);
              }}
              aria-label="More actions"
            >
              <Icon name="more-vertical" size={15} />
            </button>

            {menuOpen && (
              <div className="card-menu-dropdown right-aligned">
                <button
                  type="button"
                  className="card-menu-item"
                  onClick={e => {
                    handleCopy(e);
                    setMenuOpen(false);
                  }}
                >
                  <Icon name={copied ? 'check' : 'copy'} size={13} />
                  <span>{copied ? 'Copied!' : 'Copy Content'}</span>
                </button>
                <button
                  type="button"
                  className="card-menu-item"
                  onClick={e => {
                    e.stopPropagation();
                    setMenuOpen(false);
                    onEdit?.(item);
                  }}
                >
                  <Icon name="edit" size={13} />
                  <span>Edit Note</span>
                </button>
                <button
                  type="button"
                  className="card-menu-item danger"
                  onClick={e => {
                    e.stopPropagation();
                    setMenuOpen(false);
                    onDelete?.(item);
                  }}
                >
                  <Icon name="trash" size={13} />
                  <span>Move to Trash</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="note-card-body doc-card-body">
        <h3 className="note-card-title doc-card-title">{item?.title}</h3>
        <p className="note-card-preview doc-card-preview">{item?.content}</p>
      </div>
    </div>
  );
}
